export const getYouTubeVideoID = (url: string | undefined) => {
  if (!url) {
    return undefined;
  }
  const regex =
    /(?:https?:\/\/)?(?:www\.|m\.|music\.|gaming\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

  const match = url.match(regex);
  return match ? match[1] : null;
};
